// extracted by mini-css-extract-plugin
export default {"cls1":"NEL7sGuV_xmeBFDm_a5w","cls2":"ZFqCqwQxuycYytpQUBfo NEL7sGuV_xmeBFDm_a5w"};